import { IResourceComponentsProps, useTranslate } from "@pankod/refine-core";

import {
  Edit,
  Form,
  Input,
  useForm,
  // Avatar,
  Row,
  Col,
  // Typography,
  // Space,
  Radio,
  Checkbox,
  // InputProps,
} from "@pankod/refine-antd";

import InputMask from "react-input-mask";
import { IOrganization } from "interfaces";

// const { Text } = Typography;


export const OrganizationEdit: React.FC<IResourceComponentsProps> = () => {
  const t = useTranslate();
  const { formProps, saveButtonProps, queryResult } = useForm<IOrganization>();

  return (
    <Edit
      isLoading={queryResult?.isFetching}
      saveButtonProps={saveButtonProps}
    >
      <Form
        {...formProps}
        layout="vertical"
        initialValues={{
          // is_active: true,
          ...formProps.initialValues,
        }}
      >
        <Row gutter={[64, 0]} wrap>
                    {/* <Col xs={24} lg={6}>
                        <Space
                            direction="vertical"
                            align="center"
                            style={{
                                width: "100%",
                                textAlign: "center",
                                marginBottom: "16px",
                            }}
                        >
                            <Avatar
                                style={{
                                    width: "100%",
                                    height: "100%",
                                    maxWidth: "256px",
                                }}
                                src="/images/default-store-img-lg.png"
                                alt="Store Location"
                            />
                            <Text
                                strong
                                style={{
                                    textAlign: "center",
                                }}
                            >
                                {t("stores.selectLocation")}
                            </Text>
                        </Space>
                    </Col> */}
          <Col xs={24} lg={8}>
            <Form.Item
              label={t("organizations.fields.title")}
              name="title"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Input />
            </Form.Item>
            {/* <Form.Item
              label={t("organizations.fields.codeId")}
              name="codeId"
            >
              <Input />
            </Form.Item> */}
            <Form.Item
              label={t("organizations.fields.code")}
              name="code"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col xs={24} lg={8}>
            <Form.Item
              label={t("organizations.fields.director")}
              name="director"
            >
              <Input />
            </Form.Item>
            <Form.Item
              label={t("organizations.fields.email")}
              name="email"
            >
              <Input />
            </Form.Item>

            <Form.Item
              label={t("organizations.fields.phone")}
              name="phone"
            >
              <InputMask mask="999 (99) 999 99 99">
                {/*                                  
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore */}
                {(props: InputProps) => <Input {...props} />}
              </InputMask>
            </Form.Item>
            {/* <Form.Item
              label={t("organizations.fields.address")}
              name={["address", "text"]}
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Input.TextArea rows={8} />
            </Form.Item> */}
          </Col>
          <Col xs={24} lg={8}>
            <Form.Item label={t("organizations.fields.isActive")} name="is_active">
              <Radio.Group>
                <Radio value={true}>{t("status.enable")}</Radio>
                <Radio value={false}>{t("status.disable")}</Radio>
              </Radio.Group>
            </Form.Item>
          {/* if (isEditing(data.id)) {
                                return (
                                    <Form.Item
                                        name="is_active"
                                        style={{ margin: 0 }}
                                        valuePropName="checked"
                                    >
                                        <Checkbox />
                                    </Form.Item>
                                );
                            }
                            return <BooleanField value={value} />; */}
            <Form.Item
              // label={t("organizations.fields.debug")}
              valuePropName="checked"
              name="debug"
            >
              <Checkbox style={{fontSize: "12px"}}>{t("organizations.fields.debug")}</Checkbox>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Edit>
  );
};
